module.exports = __webpack_public_path__ + "static/media/poweredBy.a0366b1b.jpg";